import { theme as antdTheme } from "antd";
import type { ThemeConfig } from "antd";

export const lightTokens = {
  primaryColor: "#3B8FC4",
  toolbarBg: "#1B2533",
  toolbarIcon: "#8899AA",
  toolbarIconActive: "#FFFFFF",
  toolbarActiveIndicator: "#3B8FC4",
  contentBg: "#F5F7FA",
  siderBg: "#FFFFFF",
  cardBg: "#FFFFFF",
  textPrimary: "rgba(0,0,0,0.88)",
  textSecondary: "rgba(0,0,0,0.55)",
  border: "#E5E7EB",
  avatarDefaultBg: "#3B8FC4",
  warning: "#FAAD14",
  success: "#52C41A",
  error: "#FF4D4F",
};

export const darkTokens = {
  primaryColor: "#4FA3D8",
  toolbarBg: "#0F1419",
  toolbarIcon: "#6B7B8D",
  toolbarIconActive: "#FFFFFF",
  toolbarActiveIndicator: "#4FA3D8",
  contentBg: "#141719",
  siderBg: "#1A1D21",
  cardBg: "#1F2328",
  textPrimary: "rgba(255,255,255,0.88)",
  textSecondary: "rgba(255,255,255,0.55)",
  border: "#2D3239",
  avatarDefaultBg: "#3B8FC4",
  warning: "#FAAD14",
  success: "#52C41A",
  error: "#FF4D4F",
};

export type ThemeTokens = typeof lightTokens;

export function getAntdTheme(isDark: boolean): ThemeConfig {
  const tokens = isDark ? darkTokens : lightTokens;
  return {
    algorithm: isDark ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
    token: {
      colorPrimary: tokens.primaryColor,
      colorWarning: tokens.warning,
      colorSuccess: tokens.success,
      colorError: tokens.error,
      colorBgContainer: tokens.cardBg,
      colorBgLayout: tokens.contentBg,
      colorBorder: tokens.border,
      colorText: tokens.textPrimary,
      colorTextSecondary: tokens.textSecondary,
      borderRadius: 6,
    },
  };
}

export function applyCssVariables(isDark: boolean) {
  const tokens = isDark ? darkTokens : lightTokens;
  const root = document.documentElement;
  Object.entries(tokens).forEach(([key, value]) => {
    const cssVar = `--${key.replace(/([A-Z])/g, "-$1").toLowerCase()}`;
    root.style.setProperty(cssVar, value);
  });
  // agents-im compatibility — map to IM's CSS variable names
  root.style.setProperty("--accent", tokens.primaryColor);
  root.style.setProperty("--bg-primary", tokens.cardBg);
  root.style.setProperty("--bg-secondary", tokens.contentBg);
  root.style.setProperty("--bg-tertiary", isDark ? "#2a2a2a" : "#E8ECF0");
  root.style.setProperty("--bg-elevated", tokens.cardBg);
  root.style.setProperty("--bg-input", isDark ? "#1f1f1f" : "#ffffff");
  root.style.setProperty("--text-primary", tokens.textPrimary);
  root.style.setProperty("--text-secondary", tokens.textSecondary);
  root.style.setProperty("--border", tokens.border);
  root.style.setProperty("--warning", tokens.warning);
  root.style.setProperty("--success", tokens.success);
  root.style.setProperty("--error", tokens.error);
}
